module.exports = __webpack_public_path__ + "img/service_notice.e72ac2b.png";